import { HiOutlineChartBar, HiOutlineUserGroup, HiOutlineCube, HiOutlineEye, HiOutlineBell, HiOutlineLightningBolt, HiOutlinePlay } from 'react-icons/hi'
import { LuUsers, LuEye, LuZap } from 'react-icons/lu'
import SportsIcon from '@/src/components/icons/sports-icon'
import CasinoIcon from '@/src/components/icons/casino-icon'

export type IconName = 
  | 'HiOutlineChartBar'
  | 'HiOutlineUserGroup'
  | 'HiOutlineCube'
  | 'HiOutlineEye'
  | 'HiOutlineBell'
  | 'HiOutlineLightningBolt'
  | 'HiOutlinePlay'
  | 'SportsIcon'
  | 'CasinoIcon'
  | 'LuUsers'
  | 'LuEye'
  | 'LuZap'

const iconMap: Record<IconName, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = {
  HiOutlineChartBar,
  HiOutlineUserGroup,
  HiOutlineCube,
  HiOutlineEye,
  HiOutlineBell,
  HiOutlineLightningBolt,
  HiOutlinePlay,
  SportsIcon,
  CasinoIcon,
  LuUsers,
  LuEye,
  LuZap
}

export function getIcon(iconName: string): React.ComponentType<{ className?: string; style?: React.CSSProperties }> | undefined {
  return iconMap[iconName as IconName]
}

